@if (recentlyAddedProducts(); as items) {
  <products-preview
    [items]="items"
    [type]="'recentlyAddedProducts'"
    [parentNameForAnalytics]="sourceForAnalytics"
    (showCart)="showCart($event)"
  />
}
